import { NgModule, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'

@Pipe({
    name: 'isGoodTime'
})
export class InvestPackGoodTimePipe implements PipeTransform {
    transform(investpack: any): any {
        const date = new Date(investpack.suggestingInvestmentDate);
        const toDay = new Date();
        return date.toDateString() === toDay.toDateString();
    }
}
@Pipe({
    name: 'isExpire'
})
export class InvestPackExpirePipe implements PipeTransform {
    transform(investpack: any): any {
        return new Date(investpack.expiryDate) < new Date();
    }
}

@Pipe({
    name: 'nextSipDate'
})
export class NextSipDatePipe implements PipeTransform {
    transform(value: any): any {
        const nextDate = new Date();
        if (nextDate.getDate() > value) {
            nextDate.setMonth(nextDate.getMonth() + 1);
            nextDate.setDate(value);
        }
        else {
            nextDate.setDate(value);
        }
        return nextDate;
    }
}

//pipe for displaying investpack rebalance frequency
@Pipe({
    name: 'rebalFreqency'
})
export class RebalanceFrequencyPipe implements PipeTransform {
    transform(freqency: number) {
        switch (freqency) {
            case 0:
                return 'As and when required';
            case 7:
                return 'Weekly Rebalancing';
            case 15:
                return 'Fortnight Rebalancing';
            case 30:
                return 'Monthly Rebalancing';
            case 90:
                return 'Quarterly Rebalancing';
            default:
                return '';
        }
    }

}

//pipe for displaying investpack startegy
@Pipe({
    name: 'investpackStrategy'
})
export class InvestpackStrategyPipe implements PipeTransform {
    private strategies: any[] = [
        { value: 'technical_analysis', name: 'Technical Analysis' },
        { value: 'fundamental_analysis', name: 'Fundamental Analysis' },
        { value: 'asset_allocation', name: 'Asset Allocation' },
        { value: 'bottom_up', name: 'Bottom Up' },
        { value: 'top_down', name: 'Top Down' },
        { value: 'macro_views', name: 'Macro Views' },
        { value: 'growth', name: 'Growth' },
        { value: 'value', name: 'Value' },
        { value: 'momentum', name: 'Momentum' },
        { value: 'quantitative', name: 'Quantitative' },
        { value: 'factor_investing', name: 'Factor Investing' },
        { value: 'quality', name: 'Quality' },
        { value: 'thematic', name: 'Thematic' },
        { value: "tactical_rotation", name: "Tactical Rotation" },
        { value: "economic_cycle", name: "Economic Cycle" },
    ];
    transform(strategyValue: number) {
        const strategy = this.strategies.find(x => x.value === strategyValue);
        return strategy && strategy.name ? strategy.name : '---';
    }

}


@Pipe({
    name: 'rebalanceActivity'
})
export class RebalanceActivityPipe implements PipeTransform {
    transform(activity: string) {
        if (activity === 'new') {
            return 'New Addition'
        } else if (activity === 'exit') {
            return 'Complete Exit'
        } else if (activity === 'decrease') {
            return 'Partial Exit'
        } else if (activity === 'increase') {
            return 'Invest More'
        }
    }
}



@Pipe({
    name: 'categoryFilter',
    pure: false
})
export class CategoryFilterPipe implements PipeTransform {
    transform(instruments: any[], type?: string) {
        let categories: {
            equity: any[],
            gold: any[],
            etf: any[],
            mutualFund: any[]
        } = { equity: [], gold: [], etf: [], mutualFund: [] }
        let rebalanceActivty: string[] = ['new', 'increase', 'exit', 'decrease']
        if (instruments.length) {
            instruments.sort((a: any, b: any) => a.tradingSymbol?.toLowerCase() > b.tradingSymbol?.toLowerCase() ? 1 : -1);
            instruments.forEach((key) => {
                if (key.category === 'cash' && key.isGold) {
                    if (type && type === 'rebalance') {
                        if (rebalanceActivty.indexOf(key.activity) > -1) {
                            categories.gold.push(key)
                        }
                    } else if (key.quantity) {
                        categories.gold.push(key)
                    }
                } else if (key.category === 'cash' && key.isEtf) {
                    if (type && type === 'rebalance') {
                        if (rebalanceActivty.indexOf(key.activity) > -1) {
                            categories.etf.push(key)
                        }
                    } else if (key.quantity) {
                        categories.etf.push(key)
                    }
                } else if (key.category === 'cash' && !key.isGold && !key.isEtf) {
                    if (type && type === 'rebalance') {
                        if (rebalanceActivty.indexOf(key.activity) > -1) {
                            categories.equity.push(key)
                        }
                    } else if (key.quantity) {
                        categories.equity.push(key)
                    }
                } else if (key.category === 'mutual_fund') {
                    if (type && type === 'rebalance') {
                        if (rebalanceActivty.indexOf(key.activity) > -1) {
                            categories.mutualFund.push(key)
                        }
                    } else if (key.quantity) {
                        categories.mutualFund.push(key)
                    }
                }
            })
        }
        return categories
    }
}



@Pipe({
    name: 'checkCashAndMFAvaialble'
})
export class CheckCashAndMFAvaialblePipe implements PipeTransform {
    transform(instruments: any[], type: "cash" | "mutual_fund"): boolean {
        return instruments.find((x: any) => x.category === type) ? true : false
    }
}


@Pipe({
    name: 'isInvestpackAlert'
})
export class IsInvestpackAlert implements PipeTransform {
    today = new Date()

    transform(subscribedPacks: any[]) {
        let isAlert: boolean = false;
        subscribedPacks.forEach((x) => {
            if (x.isRebalancing) {
                isAlert = true
            }
            if (x.wealthcase.suggestingInvestmentDate) {
                let suggestedDate = new Date(x.wealthcase.suggestingInvestmentDate).setHours(0, 0, 0, 0)
                if (this.today.setHours(0, 0, 0, 0) === suggestedDate) {
                    isAlert = true
                }
            }
            if (x.wealthcase.isPaid) {
                const expiry = new Date(x.expiryDate);
                const diffTime = Math.abs(this.today.valueOf() - expiry.valueOf());
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                if (diffDays <= 3) {
                    isAlert = true
                }
            }
        })
        return isAlert
    }
}


@Pipe({
    name: 'investpackAlertType'
})
export class InvestpackAlertType implements PipeTransform {
    today = new Date()

    transform(pack: any, type: string) {
        let rebalance: boolean = false;
        let expired: boolean = false;
        let exiryDate: number;
        let willExpire: boolean = false
        let goodTime: boolean = false
        if (pack.isRebalancing) {
            rebalance = true
        }
        if (pack.wealthcase.suggestingInvestmentDate) {
            let suggestedDate = new Date(pack.wealthcase.suggestingInvestmentDate).setHours(0, 0, 0, 0)
            let todayDate = this.today.getTime()
            if (new Date(todayDate).setHours(0, 0, 0, 0) === suggestedDate) {
                goodTime = true
            }
        }
        if (pack.wealthcase.isPaid) {
            let expiry = moment(pack.expiryDate);
            let todayDate = moment(this.today.getTime())
            let diffDays = expiry.diff(todayDate, 'days') + 1
            if (diffDays > 0 && diffDays <= 5) {
                exiryDate = diffDays
                willExpire = true
            }

            if (diffDays <= 0 || (this.today.setHours(0, 0, 0, 0) === pack.expiryDate)) {
                expired = true
            }
        }

        if (type === 'all') {
            return (rebalance || expired || exiryDate || goodTime)
        } else if (type === 'rebalance') {
            return rebalance
        } else if (type === 'goodTime') {
            return goodTime
        } else if (type === 'expiryTime') {
            return exiryDate
        } else if (type === 'willExpire') {
            return willExpire
        } else if (type === 'expired') {
            return expired
        } else if (type === 'count') {
            let count = 0;
            if (rebalance) count++;
            if (goodTime) count++;
            if (exiryDate) count++;
            if (willExpire) count++;
            if (expired) count++;
        }
    }
}


@Pipe({
    name: 'isExternalDialogCategoryAvailable'
})
export class isExternalDialogCategoryAvailable implements PipeTransform {
    transform(allInstruments: any[], type: { section: string, category: string }) {
        let isAvailabe: boolean;
        allInstruments.forEach((key) => {
            if (type.section === 'rebalance' && key.activity) {
                if (key.category === 'cash' && key.isGold && type.category === 'gold') {
                    isAvailabe = true
                } else if (key.category === 'cash' && key.isEtf && type.category === 'etf') {
                    isAvailabe = true
                } else if (key.category === 'cash' && !key.isGold && !key.isEtf && type.category === 'cash') {
                    isAvailabe = true
                } else if (key.category === 'mutual_fund' && type.category === 'mutual_fund') {
                    isAvailabe = true
                }
            } else {
                if (key.category === 'cash' && key.isGold && type.category === 'gold') {
                    isAvailabe = true
                } else if (key.category === 'cash' && key.isEtf && type.category === 'etf') {
                    isAvailabe = true
                } else if (key.category === 'cash' && !key.isGold && !key.isEtf && type.category === 'cash') {
                    isAvailabe = true
                } else if (key.category === 'mutual_fund' && type.category === 'mutual_fund') {
                    isAvailabe = true
                }
            }
        })
        return isAvailabe
    }
}



@Pipe({
    name: 'plansOrder'
})
export class PlansOrderPipe implements PipeTransform {


    transform(plans: any[]) {
        let orderedPlans: any[] = [];
        let one_month = plans.find((x) => x.planDuration === '1M')
        let three_month = plans.find((x) => x.planDuration === '3M')
        let six_month = plans.find((x) => x.planDuration === '6M')
        let one_year = plans.find((x) => x.planDuration === '12M')

        if (one_month) {
            orderedPlans[0] = one_month
        }

        if (three_month) {
            orderedPlans[orderedPlans.length] = three_month
        }

        if (six_month) {
            orderedPlans[orderedPlans.length] = six_month
        }

        if (one_year) {
            orderedPlans[orderedPlans.length] = one_year
        }

        return orderedPlans
    }
}


@Pipe({
    name: 'planDuration'
})
export class PlanDurationPipe implements PipeTransform {
    transform(plan) {
        switch (plan.planDuration) {
            case '12M':
                return '12 Months';
            case '6M':
                return '6 Months'
            case '3M':
                return '3 Months'
            case '1M':
                return '1 Month'
        }
    }
}

@Pipe({
    name: 'sectorColors'
})
export class SectorColorsPipe implements PipeTransform {
    sectosColors: string[] = ['#FFE599', '#9AFEC1', '#BD66CC', '#EB9481', '#DDB4E4', '#1AFFA1']

    transform(i: number) {
        return this.sectosColors[i % 6]
    }
}

@Pipe({
    name: 'investpackWeight',

})
export class InvestpackWeight implements PipeTransform {
    weight = 0
    total = 0
    equity: any[] = []
    gold: any[] = []
    etf: any[] = []
    mutualFund: any[] = []
    stockTotal = 0
    transform(instruments: any, obj: any) {
        if (instruments.length) {
            instruments.forEach((key) => {
                if (key.category === 'cash' && key.isGold && key.quantity) {
                    this.gold.push(key)
                } else if (key.category === 'cash' && key.isEtf && key.quantity) {
                    this.etf.push(key)
                } else if (key.category === 'cash' && !key.isGold && !key.isEtf && key.quantity) {
                    this.equity.push(key)
                } else if (key.category === 'mutual_fund' && key.quantity) {
                    this.mutualFund.push(key)
                }
            })
            if (obj.category) {
                if (this.gold.length && obj.category === 'gold') {
                    this.total = 0
                    this.gold.forEach((x) => {
                        this.total = x.investment + this.total
                    })
                } else if (this.equity.length && obj.category === 'equity') {
                    this.total = 0
                    this.equity.forEach((x) => {
                        this.total = x.investment + this.total
                    })
                } else if (this.etf.length && obj.category === 'etf') {
                    this.total = 0
                    this.etf.forEach((x) => {
                        this.total = x.investment + this.total
                    })
                } else if (this.mutualFund.length && obj.category === 'mutualFund') {
                    this.total = 0
                    this.mutualFund.forEach((x) => {
                        this.total = x.investment + this.total
                    })
                }
            }
            if (obj.stock) {
                // this.stockTotal = 0
                // this.weight = 0
                // this.stockTotal = obj.stock.quantity * obj.stock.currentPrice
                // this.weight = (this.stockTotal / this.total) * 100
                this.weight = obj.stock.weight;
            }
        }
        return this.weight
    }
}
@Pipe({
    name: 'math'
})
export class mathPipe implements PipeTransform {
    transform(value: number) {
        return Math.abs(value)
    }
}

@Pipe({
    name: 'stockBuySell'
})
export class StockBuySellPipe implements PipeTransform {
    transform(stock: any[], type: string) {
        if (stock.length) {
            if (type === 'BUY') {
                const idx = stock.findIndex((x) => x.activity === 'increase' || x.activity === 'new')
                return idx !== -1
            }
            if (type === 'SELL') {
                const idx = stock.findIndex((x) => x.activity === 'decrease' || x.activity === 'exit')
                return idx !== -1
            }
        }
    }
}

@Pipe({
    name: 'hasInvested'
})
export class HasInvestedPipe implements PipeTransform {
    transform(investpack: any, investedData: any[]): any {
        if (investedData.length) {
            return investedData.find((x) => x.wealthcase === investpack._id)
        } else {
            return undefined
        }
    }
}

@Pipe({
    name: 'investpackPL'
})
export class InvestpackInvestedPL implements PipeTransform {
    transform(data: any, actualKey: string, currentKey: string): any {
        if (data) {
            const _actual = Math.round(data[actualKey]);
            const _current = Math.round(data[currentKey]);
            return _current - _actual;
        }
    }
}
@Pipe({
    name: 'investpackPLPercentage'
})
export class InvestpackInvestedPLPercentage implements PipeTransform {
    transform(data: any, actualKey: string, currentKey: string): any {
        if (data) {
            const _actual = Math.round(data[actualKey]);
            const _current = Math.round(data[currentKey]);
            return ((_current - _actual) / _actual) * 100;
        }
    }
}

@Pipe({
    name: 'roundOffMinInvestment'
})
export class RoundOffMinInvestment implements PipeTransform {
    transform(investmentAmt: number) {
        if (investmentAmt) {
            let remanider = investmentAmt % 500;
            if (remanider) {
                return (investmentAmt - remanider) + 500
            } else {
                return investmentAmt;
            }

        }
    }
}
@Pipe({
    name: 'isNewlyLaunchedPack'
})
export class IsNewlyLaunchedPack implements PipeTransform {
    transform(packDate: any) {
        if (packDate) {
            packDate = moment(packDate)
            let today = new Date()
            let todayDate = moment(today.getTime())
            let diffDays = Math.abs(packDate.diff(todayDate, 'days') + 1)
            if (diffDays <= 182) {
                return true
            } else {
                return false
            }
        }
    }
}

@Pipe({
    name: 'filterSelected',
    pure: false
})
export class FilterSelectedPipe implements PipeTransform {
    transform(selectedArray: any[], value: any): boolean {
        let isSelected = selectedArray.findIndex((x) => x === value)
        return isSelected >= 0
    }
}
@NgModule({
    declarations: [
        InvestPackGoodTimePipe,
        NextSipDatePipe,
        InvestPackExpirePipe,
        RebalanceFrequencyPipe,
        InvestpackStrategyPipe,
        RebalanceActivityPipe,
        CategoryFilterPipe,
        CheckCashAndMFAvaialblePipe,
        IsInvestpackAlert,
        InvestpackAlertType,
        isExternalDialogCategoryAvailable,
        PlansOrderPipe,
        PlanDurationPipe,
        SectorColorsPipe,
        InvestpackWeight,
        mathPipe,
        StockBuySellPipe,
        HasInvestedPipe,
        InvestpackInvestedPL,
        InvestpackInvestedPLPercentage,
        RoundOffMinInvestment,
        IsNewlyLaunchedPack,
        FilterSelectedPipe
    ],
    exports: [
        InvestPackGoodTimePipe,
        NextSipDatePipe,
        InvestPackExpirePipe,
        RebalanceFrequencyPipe,
        InvestpackStrategyPipe,
        RebalanceActivityPipe,
        CategoryFilterPipe,
        CheckCashAndMFAvaialblePipe,
        IsInvestpackAlert,
        InvestpackAlertType,
        isExternalDialogCategoryAvailable,
        PlansOrderPipe,
        PlanDurationPipe,
        SectorColorsPipe,
        InvestpackWeight,
        mathPipe,
        StockBuySellPipe,
        HasInvestedPipe,
        InvestpackInvestedPL,
        InvestpackInvestedPLPercentage,
        RoundOffMinInvestment,
        IsNewlyLaunchedPack,
        FilterSelectedPipe
    ],
})
export class InvestPackPipeModule { }